let FILE_HOST = '//file-dev.joyorders.com'
let API_HOST = '//api-dev.joyorders.com'
let API2_HOST = '//localhost:8302'
let API3_HOST = 'https://s.joyorders.com'
let AIService_HOST = 'https://service-dev.joyorders.com'
let ONEKEY_HOST = '//onekey-dev.joyorders.com'
let BASE_HOST = '//www-dev.joyorders.com'
let ADMIN_HOST = 'https://admin-dev.joyorders.com'
let default_crawler = 'api-dev'
window.env = 'test'
if (window.env == 'test') {
  FILE_HOST = '//file-test.joyorders.com'
  API_HOST = '//api-test.joyorders.com'
  API2_HOST = 'https://api2-test.joyorders.com'
  API3_HOST = 'https://s.joyorders.com'
  AIService_HOST = 'https://service.joyorders.com'
  ONEKEY_HOST = '//onekey-test.joyorders.com'
  BASE_HOST = '//www-test.joyorders.com'
  ADMIN_HOST = 'https://admin-test.joyorders.com'
  default_crawler = 'api-test'
}
if (window.location.host === 'client-test.joyorders.com' || window.location.host === 'www-test.joyorders.com') {
  FILE_HOST = '//file-test.joyorders.com'
  API_HOST = '//api-test.joyorders.com'
  API2_HOST = 'https://api2-test.joyorders.com'
  API3_HOST = 'https://s.joyorders.com'
  AIService_HOST = 'https://service-test.joyorders.com'
  ONEKEY_HOST = '//onekey-test.joyorders.com'
  BASE_HOST = '//www-test.joyorders.com'
  ADMIN_HOST = 'https://admin-test.joyorders.com'
  default_crawler = 'api-test'
  window.env = 'test'
} else if (window.location.host === 'client.joyorders.com' || window.location.host === 'www.joyorders.com') {
  FILE_HOST = '//file.joyorsders.com'
  API_HOST = '//api.joyorders.com'
  API2_HOST = 'https://api2.joyorders.com'
  API3_HOST = 'https://s.joyorders.com'
  AIService_HOST = 'https://service.joyorders.com'
  ONEKEY_HOST = '//onekey.joyorders.com'
  BASE_HOST = '//www.joyorders.com'
  ADMIN_HOST = 'https://admin.joyorders.com'
  default_crawler = 'api'
  window.env = 'prod'
}
const lackDisplay = ['取消任务', '等补货, 期间随时可以取消.', '缺货商品取消其余下单', '缺货商品等补货其余先下单', '其他请备注']

const SPEC_MAPPER = {
  color: '颜色',
  size: '尺码',
  volume: '容量',
  width: '宽度',
  band: '胸围',
  cup: '罩杯',
  series: '系列',
  height: '高度',
  length: '宽度',
  fabric: '面料',
  material: '材质'
}

const APPPages = [
  {url:'tabBar/merchant',name:'首页'},
  {url:'articles/list',name:'发现'},
  {url:'tabBar/message',name:'消息'},
  {url:'tabBar/user',name:'我的'},
  {url:'tabBar/cart',name:'待买清单'},
  {url:'product/detail',name:'商品详情',query:{id:''}},
  {url:'article/detail',name:'帖子详情',query:{id:''}}
]

const specOrder = ['color', 'fabric', 'length', 'height', 'width', 'series', 'material', 'size', 'volume', 'band', 'cup']

const CURRENCIES = [
  {value: 'USD', symbol: '$', name: '美元', name_en: 'US Dollar'},
  {value: 'EUR', symbol: '€', name: '欧元', name_en: 'Euro'},
  {value: 'GBP', symbol: '£', name: '英镑', name_en: 'Pound Sterling'},
  {value: 'JPY', symbol: '¥', name: '日元', name_en: 'Japanese Yen'},
  {value: 'KRW', symbol: '₩', name: '韩元', name_en: 'South Korean Won'},
  {value: 'AUD', symbol: '$', name: '澳元', name_en: 'Australian Dollar'},
  {value: 'CNY', symbol: '¥', name: '人民币', name_en: 'Chinese Yuan Renminbi'},
  {value: 'CAD', symbol: '$', name: '加元', name_en: 'Canadian Dollar'},
  {value: 'HKD', symbol: '$', name: '港元', name_en: 'Hong Kong Dollar'},
  {value: 'TWD', symbol: '$', name: '新台币', name_en: 'Taiwanese New Dollar'},
  {value: 'SGD', symbol: '$', name: '新加坡元', name_en: 'Singapore Dollar'},
  {value: 'NZD', symbol: '$', name: '新西兰元', name_en: 'New Zealand Dollar'},
  {value: 'MOP', symbol: '$', name: '澳门元', name_en: 'Macau Pataca'},
  {value: 'CHF', symbol: 'Fr', name: '瑞士法郎', name_en: 'Swiss Franc'},
  {value: 'RUB', symbol: '₽', name: '俄罗斯卢布', name_en: 'Russian Ruble'},
  {value: 'THB', symbol: '฿', name: '泰铢', name_en: 'Thai Baht'},
  {value: 'DKK', symbol: 'kr', name: '丹麦克朗', name_en: 'Danish Krone'},
  {value: 'ZAR', symbol: 'Sk', name: '南非兰特', name_en: 'South African Rand'},
  {value: 'INR', symbol: '₹', name: '印度卢比', name_en: 'Indian Rupee'},
  {value: 'TRY', symbol: '$', name: '土耳其里拉', name_en: 'Turkish Lira'},
  {value: 'MXN', symbol: '$', name: '墨西哥比索', name_en: 'Mexican Peso'},
  {value: 'BRL', symbol: '$', name: '巴西雷亚尔', name_en: 'Brazilian Real'},
  {value: 'NOK', symbol: 'kr', name: '挪威克郎', name_en: 'Norwegian Krone'},
  {value: 'SEK', symbol: 'kr', name: '瑞典克朗', name_en: 'Swedish Krona'},
  {value: 'XXX', symbol: '¤', name: '其他货币', name_en: 'Other Currencies'}
]

const POSTMENU = [
  {label: '发现', url: '/explore'},
  {label: '发布', url: '/publish'},
  {label: '助手', url: '/assistant'},
  {label: '我的', url: '/mypost'},
]

const SIDEMENU = [
  {label: '发布任务', url: '/customer/publish_task/cart'},
  {label: '我的任务', url: '/customer/task/list'},
  {label: '账户信息', url: '/customer/profile', name: '我的账户'},
  {label: '收货地址', url: '/customer/address/list'},
  //{label: '发布文章', url: '/publish_post'},
  //{label: '文章列表', url: '/explore'},
  {label: '退出', url: '/logout'}
]

const USERMENU = [
  // {label: '下单账户', url: '/buyer/dashboard', border: true},
  {label: '发布任务', url: '/customer/publish_task/cart'},
  {label: '我的任务', url: '/customer/task/list'},
  {label: '账户信息', url: '/customer/profile', name: '我的账户'},
  {label: '收货地址', url: '/customer/address/list'},
  //{label: '发布文章', url: '/publish_post'},
  //{label: '文章列表', url: '/explore'},
  // {label: '退出', url: '/logout', logout: true}
]

const SINGLESIDEMENU = [
  {label: '概览', url: '/buyer/dashboard', showTitle: false},
  {label: '发起任务', url: '/buyer/publish_task/index', showTitle: false},
  {label: '我的任务', url: '/buyer/task/list'},
  {label: '工单列表', url: '/buyer/task/ticketlist', noexternal: true},
  {label: '待买清单', url: '/buyer/task/cartlist', noexternal: true},
  //{label: '商家订单', url: '/buyer/merchantOrder/list'},
  {label: '邮件列表', url: '/buyer/task/maillist', noexternal: true},
  // {label: '物流监控', url: '/buyer/task/monitor_express', noexternal: true},
  {label: '物流账单', url: '/buyer/task/express_bill', noexternal: true},
  {label: '账单结算', url: '/buyer/task/amount_bill', noexternal: true,showTitle:false},
  {label: '礼卡管理', url: '/buyer/task/cardlist', noexternal: true},
  {label: '收支明细', url: '/buyer/income'},
  {label: '提现方式', url: '/buyer/withdraw'},
  //{label: '发布文章', url: '/publish_post',showTitle: false},
  //{label: '文章列表', url: '/explore',showTitle: false}
  // {label: '退出', url: '/logout',logout: true}
]

const SHIPPINGMANAGERSIDEMENU = [
  {label: '概览', url: '/buyer/dashboard', showTitle: false},
  {label: '我的任务', url: '/buyer/task/list'},
  //{label: '商家订单', url: '/buyer/merchantOrder/list'},
]

const BANKLIST = [
  {value: '工商银行', label: '工商银行'},
  {value: '建设银行', label: '建设银行'},
  {value: '中国银行', label: '中国银行'},
  {value: '农业银行', label: '农业银行'},
  {value: '交通银行', label: '交通银行'},
  {value: '招商银行', label: '招商银行'},
  {value: '邮政银行', label: '邮政银行'},
  {value: '中信银行', label: '中信银行'},
  {value: '民生银行', label: '民生银行'},
  {value: '兴业银行', label: '兴业银行'},
  {value: '光大银行', label: '光大银行'},
  {value: '平安银行', label: '平安银行'},
  {value: '华夏银行', label: '华夏银行'},
  {value: '浦发银行', label: '浦发银行'},
  {value: '广发银行', label: '广发银行'},
  {value: '北京银行', label: '北京银行'},
  {value: '浙商银行', label: '浙商银行'},
  {value: '渤海银行', label: '渤海银行'},
  {value: '上海银行', label: '上海银行'},
  {value: '宁波银行', label: '宁波银行'},
  {value: '恒丰银行', label: '恒丰银行'}
]

const COUNTRIES = [
  {value: 'CN', name: '中国大陆', name_en: 'China', img: require('../ico/china.png')},
  {value: 'US', name: '美国', name_en: 'United States', img: require('../ico/america.png')},
  {value: 'GB', name: '英国', name_en: 'United Kingdom', img: require('../ico/british.png')},
  {value: 'JP', name: '日本', name_en: 'Japan', img: require('../ico/japan.png')},
  {value: 'DE', name: '德国', name_en: 'Germany', img: require('../ico/german.png')},
  {value: 'HK', name: '中国香港', name_en: 'Hong Kong', img: require('../flag/hk.jpg')},
  {value: 'KR', name: '韩国', name_en: 'South Korea', img: require('../flag/kr.png')},
  {value: 'AU', name: '澳大利亚', name_en: 'Australia', img: require('../flag/au.png')},
  {value: 'AL', name: '阿尔巴尼亚', name_en: 'Albania', img: require('../flag/al.png')},
  {value: 'DZ', name: '阿尔及利亚', name_en: 'Algeria', img: require('../flag/dz.png')},
  {value: 'AF', name: '阿富汗', name_en: 'Afghanistan', img: require('../flag/af.png')},
  {value: 'AR', name: '阿根廷', name_en: 'Argentina', img: require('../flag/ar.png')},
  {value: 'AE', name: '阿联酋', name_en: 'United Arab Emirates', img: require('../flag/ae.png')},
  {value: 'AW', name: '阿鲁巴', name_en: 'Aruba'},
  {value: 'OM', name: '阿曼', name_en: 'Oman'},
  {value: 'AZ', name: '阿塞拜疆', name_en: 'Azerbaijan'},
  {value: 'EG', name: '埃及', name_en: 'Egypt', img: require('../flag/ag.png')},
  {value: 'ET', name: '埃塞俄比亚', name_en: 'Ethiopia'},
  {value: 'IE', name: '爱尔兰', name_en: 'Ireland'},
  {value: 'EE', name: '爱沙尼亚', name_en: 'Estonia'},
  {value: 'AD', name: '安多拉', name_en: 'Andorra'},
  {value: 'AO', name: '安哥拉', name_en: 'Angola'},
  {value: 'AI', name: '安圭拉岛', name_en: 'Anguilla'},
  {value: 'AG', name: '安提瓜和巴布达', name_en: 'Antigua & Barbuda'},
  {value: 'AT', name: '奥地利', name_en: 'Austria', img: require('../flag/at.png')},
  {value: 'AX', name: '奥兰群岛', name_en: 'Aland Islands'},
  {value: 'BB', name: '巴巴多斯', name_en: 'Barbados'},
  {value: 'PG', name: '巴布亚新几内亚', name_en: 'Papua New Guinea'},
  {value: 'BS', name: '巴哈马', name_en: 'Bahamas'},
  {value: 'PK', name: '巴基斯坦', name_en: 'Pakistan'},
  {value: 'PY', name: '巴拉圭', name_en: 'Paraguay'},
  {value: 'BH', name: '巴林', name_en: 'Bahrain'},
  {value: 'PA', name: '巴拿马', name_en: 'Panama'},
  {value: 'BR', name: '巴西', name_en: 'Brazil', img: require('../flag/br.png')},
  {value: 'BY', name: '白俄罗斯', name_en: 'Belarus', img: require('../flag/by.png')},
  {value: 'BM', name: '百慕大', name_en: 'Bermuda'},
  {value: 'BG', name: '保加利亚', name_en: 'Bulgaria'},
  {value: 'MP', name: '北马里亚纳群岛', name_en: 'Northern Mariana Islands'},
  {value: 'BJ', name: '贝宁', name_en: 'Benin'},
  {value: 'BE', name: '比利时', name_en: 'Belgium', img: require('../flag/be.png')},
  {value: 'IS', name: '冰岛', name_en: 'Iceland', img: require('../flag/is.png')},
  {value: 'PR', name: '波多黎各', name_en: 'Puerto Rico'},
  {value: 'PL', name: '波兰', name_en: 'Poland', img: require('../flag/pl.png')},
  {value: 'BA', name: '波斯尼亚和黑塞哥维那', name_en: 'Bosnia & Herzegovina'},
  {value: 'BO', name: '玻利维亚', name_en: 'Bolivia'},
  {value: 'BZ', name: '伯利兹', name_en: 'Belize'},
  {value: 'BW', name: '博茨瓦纳', name_en: 'Botswana'},
  {value: 'BT', name: '不丹', name_en: 'Bhutan'},
  {value: 'BF', name: '布基纳法索', name_en: 'Burkina Faso'},
  {value: 'BI', name: '布隆迪', name_en: 'Burundi'},
  {value: 'GQ', name: '赤道几内亚', name_en: 'Equatorial Guinea'},
  {value: 'DK', name: '丹麦', name_en: 'Denmark', img: require('../flag/dk.png')},
  {value: 'TL', name: '东帝汶', name_en: 'Timor-Leste'},
  {value: 'TG', name: '多哥', name_en: 'Togo'},
  {value: 'DM', name: '多米尼加', name_en: 'Dominica'},
  {value: 'DO', name: '多米尼加共和国', name_en: 'Dominican Republic'},
  {value: 'RU', name: '俄罗斯', name_en: 'Russia', img: require('../flag/ru.png')},
  {value: 'EC', name: '厄瓜多尔', name_en: 'Ecuador'},
  {value: 'ER', name: '厄立特里亚', name_en: 'Eritrea'},
  {value: 'FR', name: '法国', name_en: 'France', img: require('../flag/fr.png')},
  {value: 'FO', name: '法罗群岛', name_en: 'Faroe Islands'},
  {value: 'PF', name: '法属波利尼西亚', name_en: 'French Polynesia'},
  {value: 'GF', name: '法属圭亚那', name_en: 'French Guiana'},
  {value: 'VA', name: '梵蒂冈城', name_en: 'Vatican City'},
  {value: 'PH', name: '菲律宾', name_en: 'Philippines'},
  {value: 'FJ', name: '斐济', name_en: 'Fiji'},
  {value: 'FI', name: '芬兰', name_en: 'Finland', img: require('../flag/fi.png')},
  {value: 'CV', name: '佛得角', name_en: 'Cape Verde'},
  {value: 'CG', name: '刚果共和国', name_en: 'Congo - Republic of'},
  {value: 'CD', name: '刚果民主共和国', name_en: 'Congo - Democratic Republic of'},
  {value: 'CO', name: '哥伦比亚', name_en: 'Colombia'},
  {value: 'CR', name: '哥斯达黎加', name_en: 'Costa Rica'},
  {value: 'GL', name: '格林兰岛', name_en: 'Greenland'},
  {value: 'GD', name: '格林纳达', name_en: 'Grenada'},
  {value: 'GE', name: '格鲁吉亚', name_en: 'Georgia'},
  {value: 'GG', name: '根西岛', name_en: 'Guernsey'},
  {value: 'GP', name: '瓜德罗普岛', name_en: 'Guadeloupe'},
  {value: 'GU', name: '关岛', name_en: 'Guam'},
  {value: 'GY', name: '圭亚那', name_en: 'Guyana'},
  {value: 'KZ', name: '哈萨克斯坦', name_en: 'Kazakhstan'},
  {value: 'HT', name: '海地', name_en: 'Haiti'},
  {value: 'NL', name: '荷兰', name_en: 'Netherlands', img: require('../flag/nl.png')},
  {value: 'AN', name: '荷属安地列斯群岛', name_en: 'Netherlands Antilles'},
  {value: 'ME', name: '黑山共和国', name_en: 'Montenegro'},
  {value: 'HN', name: '洪都拉斯', name_en: 'Honduras'},
  {value: 'KI', name: '基里巴斯', name_en: 'Kiribati'},
  {value: 'DJ', name: '吉布提', name_en: 'Djibouti'},
  {value: 'KG', name: '吉尔吉斯斯坦', name_en: 'Kyrgyzstan'},
  {value: 'GN', name: '几内亚', name_en: 'Guinea'},
  {value: 'GW', name: '几内亚比绍', name_en: 'Guinea-Bissau'},
  {value: 'CA', name: '加拿大', name_en: 'Canada', img: require('../flag/ca.png')},
  {value: 'GH', name: '加纳', name_en: 'Ghana'},
  {value: 'GA', name: '加蓬', name_en: 'Gabon'},
  {value: 'KH', name: '柬埔寨', name_en: 'Cambodia'},
  {value: 'CZ', name: '捷克共和国', name_en: 'Czech Republic'},
  {value: 'ZW', name: '津巴布韦', name_en: 'Zimbabwe'},
  {value: 'CM', name: '喀麦隆', name_en: 'Cameroon'},
  {value: 'QA', name: '卡塔尔', name_en: 'Qatar'},
  {value: 'KY', name: '开曼群岛', name_en: 'Cayman Islands'},
  {value: 'CS', name: '科索沃', name_en: 'Kosovo'},
  {value: 'CI', name: '科特迪瓦', name_en: 'Cote D\'Ivoire'},
  {value: 'KW', name: '科威特', name_en: 'Kuwait'},
  {value: 'HR', name: '克罗地亚', name_en: 'Croatia'},
  {value: 'KE', name: '肯尼亚', name_en: 'Kenya'},
  {value: 'CK', name: '库克群岛', name_en: 'Cook Islands'},
  {value: 'LV', name: '拉脱维亚', name_en: 'Latvia'},
  {value: 'LS', name: '莱索托', name_en: 'Lesotho'},
  {value: 'LA', name: '老挝', name_en: 'Laos'},
  {value: 'LB', name: '黎巴嫩', name_en: 'Lebanon'},
  {value: 'LT', name: '立陶宛', name_en: 'Lithuania'},
  {value: 'LR', name: '利比里亚', name_en: 'Liberia'},
  {value: 'LY', name: '利比亚', name_en: 'Libya'},
  {value: 'LI', name: '列支敦士登', name_en: 'Liechtenstein'},
  {value: 'RE', name: '留尼旺岛', name_en: 'Reunion'},
  {value: 'LU', name: '卢森堡', name_en: 'Luxembourg'},
  {value: 'RW', name: '卢旺达', name_en: 'Rwanda'},
  {value: 'RO', name: '罗马尼亚', name_en: 'Romania'},
  {value: 'MG', name: '马达加斯加', name_en: 'Madagascar'},
  {value: 'MV', name: '马尔代夫', name_en: 'Maldives', img: require('../flag/mv.png')},
  {value: 'MT', name: '马耳他', name_en: 'Malta'},
  {value: 'MW', name: '马拉维', name_en: 'Malawi'},
  {value: 'MY', name: '马来西亚', name_en: 'Malaysia'},
  {value: 'ML', name: '马里', name_en: 'Mali'},
  {value: 'MK', name: '马其顿', name_en: 'Macedonia'},
  {value: 'MH', name: '马绍尔群岛', name_en: 'Marshall Islands'},
  {value: 'MQ', name: '马提尼克岛', name_en: 'Martinique'},
  {value: 'MU', name: '毛里求斯', name_en: 'Mauritius'},
  {value: 'MR', name: '毛里塔尼亚', name_en: 'Mauritania'},
  {value: 'AS', name: '美属萨摩亚', name_en: 'American Samoa'},
  {value: 'VI', name: '美属维京群岛', name_en: 'US Virgin Island'},
  {value: 'MN', name: '蒙古', name_en: 'Mongolia'},
  {value: 'MS', name: '蒙特塞拉特', name_en: 'Montserrat'},
  {value: 'BD', name: '孟加拉', name_en: 'Bangladesh'},
  {value: 'PE', name: '秘鲁', name_en: 'Peru'},
  {value: 'FM', name: '密克罗尼西亚', name_en: 'Micronesia'},
  {value: 'MD', name: '摩尔多瓦', name_en: 'Moldova'},
  {value: 'MA', name: '摩洛哥', name_en: 'Morocco'},
  {value: 'MC', name: '摩纳哥', name_en: 'Monaco'},
  {value: 'MZ', name: '莫桑比克', name_en: 'Mozambique'},
  {value: 'MX', name: '墨西哥', name_en: 'Mexico', img: require('../flag/mx.png')},
  {value: 'NA', name: '纳米比亚', name_en: 'Namibia'},
  {value: 'ZA', name: '南非', name_en: 'South Africa', img: require('../flag/za.png')},
  {value: 'NP', name: '尼泊尔', name_en: 'Nepal'},
  {value: 'NI', name: '尼加拉瓜', name_en: 'Nicaragua'},
  {value: 'NE', name: '尼日尔', name_en: 'Niger'},
  {value: 'NG', name: '尼日利亚', name_en: 'Nigeria'},
  {value: 'NO', name: '挪威', name_en: 'Norway', img: require('../flag/no.png')},
  {value: 'NF', name: '诺福克岛', name_en: 'Norfolk Island'},
  {value: 'PW', name: '帕劳', name_en: 'Palau'},
  {value: 'PT', name: '葡萄牙', name_en: 'Portugal', img: require('../flag/pt.png')},
  {value: 'SE', name: '瑞典', name_en: 'Sweden', img: require('../flag/se.png')},
  {value: 'CH', name: '瑞士', name_en: 'Switzerland', img: require('../flag/ch.png')},
  {value: 'SV', name: '萨尔瓦多', name_en: 'El Salvador'},
  {value: 'WS', name: '萨摩亚', name_en: 'Samoa'},
  {value: 'RS', name: '塞尔维亚', name_en: 'Serbia'},
  {value: 'SL', name: '塞拉利昂', name_en: 'Sierra Leone'},
  {value: 'SN', name: '塞内加尔', name_en: 'Senegal'},
  {value: 'CY', name: '塞浦路斯', name_en: 'Cyprus'},
  {value: 'SC', name: '塞舌尔群岛', name_en: 'Seychelles'},
  {value: 'SA', name: '沙特阿拉伯', name_en: 'Saudi Arabia'},
  {value: 'KN', name: '圣基茨和尼维斯', name_en: 'St, Kitts & Nevis'},
  {value: 'LC', name: '圣卢西亚', name_en: 'St, Lucia'},
  {value: 'MF', name: '圣马丁', name_en: 'St, Martin'},
  {value: 'SM', name: '圣马利诺', name_en: 'San Marino'},
  {value: 'VC', name: '圣文森特和格林纳丁斯', name_en: 'St, Vincent & the Grenadines'},
  {value: 'LK', name: '斯里兰卡', name_en: 'Sri Lanka'},
  {value: 'SK', name: '斯洛伐克', name_en: 'Slovakia'},
  {value: 'SI', name: '斯洛文尼亚', name_en: 'Slovenia'},
  {value: 'SZ', name: '斯威士兰', name_en: 'Swaziland'},
  {value: 'SR', name: '苏里南', name_en: 'Suriname'},
  {value: 'SB', name: '所罗门群岛', name_en: 'Solomon Islands'},
  {value: 'TJ', name: '塔吉克斯坦', name_en: 'Tajikistan'},
  {value: 'TH', name: '泰国', name_en: 'Thailand', img: require('../flag/th.png')},
  {value: 'TZ', name: '坦桑尼亚', name_en: 'Tanzania'},
  {value: 'TO', name: '汤加群岛', name_en: 'Tonga'},
  {value: 'TC', name: '特克斯和凯科斯', name_en: 'Turks & Caicos'},
  {value: 'TT', name: '特立尼达和多巴哥', name_en: 'Trinidad & Tobago'},
  {value: 'TN', name: '突尼斯', name_en: 'Tunisia'},
  {value: 'TR', name: '土耳其', name_en: 'Turkey'},
  {value: 'TM', name: '土库曼斯坦', name_en: 'Turkmenistan'},
  {value: 'TV', name: '吐瓦鲁', name_en: 'Tuvalu'},
  {value: 'WF', name: '瓦利斯群岛和富图纳', name_en: 'Wallis & Futuna Islands'},
  {value: 'VU', name: '瓦努阿图', name_en: 'Vanuatu'},
  {value: 'GT', name: '危地马拉', name_en: 'Guatemala'},
  {value: 'VE', name: '委内瑞拉', name_en: 'Venezuela'},
  {value: 'BN', name: '文莱', name_en: 'Brunei'},
  {value: 'UG', name: '乌干达', name_en: 'Uganda'},
  {value: 'UA', name: '乌克兰', name_en: 'Ukraine'},
  {value: 'UY', name: '乌拉圭', name_en: 'Uruguay'},
  {value: 'UZ', name: '乌兹别克斯坦', name_en: 'Uzbekistan'},
  {value: 'ES', name: '西班牙', name_en: 'Spain', img: require('../flag/es.png')},
  {value: 'GR', name: '希腊', name_en: 'Greece', img: require('../flag/gr.png')},
  {value: 'SG', name: '新加坡', name_en: 'Singapore', img: require('../flag/sg.png')},
  {value: 'NC', name: '新喀里多尼亚', name_en: 'New Caledonia'},
  {value: 'NZ', name: '新西兰', name_en: 'New Zealand', img: require('../flag/nz.png')},
  {value: 'HU', name: '匈牙利', name_en: 'Hungary'},
  {value: 'JM', name: '牙买加', name_en: 'Jamaica'},
  {value: 'AM', name: '亚美尼亚', name_en: 'Armenia'},
  {value: 'YE', name: '也门', name_en: 'Yemen'},
  {value: 'IQ', name: '伊拉克', name_en: 'Iraq', img: require('../flag/iq.png')},
  {value: 'IL', name: '以色列', name_en: 'Israel', img: require('../flag/il.png')},
  {value: 'IT', name: '意大利', name_en: 'Italy', img: require('../flag/it.png')},
  {value: 'IN', name: '印度', name_en: 'India', img: require('../flag/in.png')},
  {value: 'ID', name: '印度尼西亚', name_en: 'Indonesia'},
  {value: 'VG', name: '英属维尔京群岛', name_en: 'British Virgin Islands'},
  {value: 'JO', name: '约旦', name_en: 'Jordan'},
  {value: 'VN', name: '越南', name_en: 'Vietnam', img: require('../flag/vn.png')},
  {value: 'GM', name: '赞比亚', name_en: 'Gambia'},
  {value: 'ZM', name: '赞比亚', name_en: 'Zambia'},
  {value: 'JE', name: '泽西岛', name_en: 'Jersey'},
  {value: 'TD', name: '乍得', name_en: 'Chad'},
  {value: 'GI', name: '直布罗陀', name_en: 'Gibraltar'},
  {value: 'CL', name: '智利', name_en: 'Chile'},
  {value: 'CF', name: '中非共和国', name_en: 'Central African Republic'},
  {value: 'MO', name: '中国澳门', name_en: 'Macau', img: require('../flag/mo.jpg')},
  {value: 'TW', name: '中国台湾', name_en: 'Taiwan', img: require('../flag/tw.png')}
]
const areaCode = [
  {key: '93', value: '阿富汗(+93)'},
  {key: '355', value: '阿尔巴尼亚(+355)'},
  {key: '213', value: '阿尔及尼亚(+213)'},
  {key: '376', value: '安道尔(+376)'},
  {key: '1264', value: '安圭拉岛(英)(+1264)'},
  {key: '244', value: '安哥拉(+244)'},
  {key: '1268', value: '安提瓜和巴布达(+1268)'},
  {key: '54', value: '阿根廷(+54)'},
  {key: '374', value: '亚美尼亚(+374)'},
  {key: '247', value: '阿森松(英)(+247)'},
  {key: '61', value: '澳大利亚(+61)', reg: 'en-au'},
  {key: '43', value: '奥地利(+43)'},
  {key: '994', value: '阿塞拜疆(+994)'},
  {key: '1242', value: '巴哈马国(+1242)'},
  {key: '973', value: '巴林(+973)'},
  {key: '880', value: '孟加拉国(+880)'},
  {key: '1246', value: '巴巴多斯(+1246)'},
  {key: '375', value: '白俄罗斯(+375)'},
  {key: '32', value: '比利时(+32)'},
  {key: '501', value: '伯利兹(+501)'},
  {key: '229', value: '贝宁(+229)'},
  {key: '1441', value: '百慕大群岛(英)(+1441)'},
  {key: '591', value: '玻利维亚(+591)'},
  {key: '267', value: '博茨瓦纳(+267)'},
  {key: '55', value: '巴西(+55)'},
  {key: '673', value: '文莱(+673)'},
  {key: '359', value: '保加利亚(+359)'},
  {key: '226', value: '布基纳法索(+226)'},
  {key: '95', value: '缅甸(+95)'},
  {key: '257', value: '布隆迪(+257)'},
  {key: '237', value: '喀麦隆(+237)'},
  {key: '1', value: '美国/加拿大(+1)', reg: 'en-us'},
  {key: '1345', value: '开曼群岛(英)(+1345)'},
  {key: '236', value: '中非(+236)'},
  {key: '235', value: '乍得(+235)'},
  {key: '56', value: '智利(+56)'},
  {key: '86', value: '中国(+86)', reg: 'zh-cn'},
  {key: '57', value: '哥伦比亚(+57)'},
  {key: '242', value: '刚果(+242)'},
  {key: '682', value: '科克群岛(新)(+682)'},
  {key: '506', value: '哥斯达黎加(+506)'},
  {key: '53', value: '古巴(+53)'},
  {key: '357', value: '塞浦路斯(+357)'},
  {key: '420', value: '捷克共和国(+420)'},
  {key: '45', value: '丹麦(+45)', reg: 'en-dk'},
  {key: '253', value: '吉布提(+253)'},
  {key: '1890', value: '多米尼加共和国(+1890)'},
  {key: '593', value: '厄瓜多尔(+593)'},
  {key: '20', value: '埃及(+20)'},
  {key: '503', value: '萨尔瓦多(+503)'},
  {key: '372', value: '爱沙尼亚(+372)'},
  {key: '251', value: '埃塞俄比亚(+251)'},
  {key: '679', value: '斐济(+679)'},
  {key: '358', value: '芬兰(+358)', reg: 'en-fi'},
  {key: '33', value: '法国(+33)', reg: 'fr-fr'},
  {key: '594', value: '法属圭亚那(+594)'},
  {key: '241', value: '加蓬(+241)'},
  {key: '220', value: '冈比亚(+220)'},
  {key: '995', value: '格鲁吉亚(+995)'},
  {key: '49', value: '德国(+49)', reg: 'de-de'},
  {key: '233', value: '加纳(+233)'},
  {key: '350', value: '直布罗陀(英)(+350)'},
  {key: '30', value: '希腊(+30)'},
  {key: '1809', value: '格林纳达(+1809)'},
  {key: '1671', value: '关岛 (+1671)'},
  {key: '502', value: '危地马拉(+502)'},
  {key: '224', value: '几内亚 (+224)'},
  {key: '592', value: '圭亚那 (+592)'},
  {key: '509', value: '海地(+509)'},
  {key: '504', value: '洪都拉斯(+504)'},
  {key: '852', value: '中国香港(+852)', reg: 'zh-hk'},
  {key: '36', value: '匈牙利(+36)'},
  {key: '354', value: '冰岛(+354)'},
  {key: '91', value: '印度(+91)', reg: 'en-in'},
  {key: '62', value: '印度尼西亚(+62)', reg: 'en-id'},
  {key: '98', value: '伊朗(+98)'},
  {key: '964', value: '伊拉克(+964)'},
  {key: '353', value: '爱尔兰(+353)', reg: 'en-ie'},
  {key: '972', value: '以色列(+972)', reg: 'en-il'},
  {key: '39', value: '意大利(+39)'},
  {key: '225', value: '科特迪瓦(+225)'},
  {key: '1876', value: '牙买加(+1876)'},
  {key: '81', value: '日本(+81)', reg: 'ja-jp'},
  {key: '962', value: '约旦(+962)'},
  {key: '855', value: '柬埔寨(+855)'},
  {key: '327', value: '哈萨克斯坦 (+327)'},
  {key: '254', value: '肯尼亚(+254)'},
  {key: '82', value: '韩国(+82)', reg: 'ko-kr'},
  {key: '965', value: '科威特(+965)'},
  {key: '331', value: '吉尔吉斯斯坦(+331)'},
  {key: '856', value: '老挝(+856)'},
  {key: '371', value: '拉脱维亚(+371)'},
  {key: '266', value: '黎巴嫩(+266)'},
  {key: '231', value: '利比里亚(+231)'},
  {key: '218', value: '利比亚(+218)'},
  {key: '423', value: '列支敦士登(+423)'},
  {key: '370', value: '立陶宛(+370)'},
  {key: '352', value: '卢森堡(+352)'},
  {key: '853', value: '中国澳门(+853)'},
  {key: '261', value: '马达加斯加(+261)'},
  {key: '265', value: '马拉维(+265)'},
  {key: '60', value: '马来西亚(+60)'},
  {key: '960', value: '马尔代夫(+960)'},
  {key: '223', value: '马里(+223)'},
  {key: '356', value: '马耳他(+356)'},
  {key: '1670', value: '马里亚纳群岛(+1670)'},
  {key: '230', value: '毛里求斯(+230)'},
  {key: '52', value: '墨西哥(+52)'},
  {key: '373', value: '摩尔多瓦共和国(+373)'},
  {key: '377', value: '摩纳哥(+377)'},
  {key: '976', value: '蒙古(+976)'},
  {key: '1664', value: '蒙特塞拉特(+1664)'},
  {key: '212', value: '摩洛哥(+212)'},
  {key: '258', value: '莫桑比克(+258)'},
  {key: '264', value: '纳米尼亚(+264)'},
  {key: '674', value: '瑙鲁(+674)'},
  {key: '977', value: '尼泊尔(+977)'},
  {key: '599', value: '荷属安的列斯(+599)'},
  {key: '31', value: '荷兰(+31)'},
  {key: '64', value: '新西兰(+64)', reg: 'en-nz'},
  {key: '505', value: '尼加拉瓜(+505)'},
  {key: '227', value: '尼日尔(+227)'},
  {key: '234', value: '尼日利亚(+234)'},
  {key: '850', value: '朝鲜(+850)'},
  {key: '47', value: '挪威(+47)', reg: 'en-no'},
  {key: '968', value: '阿曼(+968)'},
  {key: '92', value: '巴基斯坦(+92)'},
  {key: '507', value: '巴拿马(+507)'},
  {key: '675', value: '巴布亚新几内亚(+675)'},
  {key: '595', value: '巴拉圭(+595)'},
  {key: '51', value: '秘鲁(+51)'},
  {key: '63', value: '菲律宾(+63)'},
  {key: '48', value: '波兰(+48)'},
  {key: '689', value: '法属波利尼西亚(+689)'},
  {key: '351', value: '葡萄牙(+351)'},
  {key: '1787', value: '波多黎各(+1787)'},
  {key: '974', value: '卡塔尔(+974)'},
  {key: '262', value: '留尼汪(+262)'},
  {key: '40', value: '罗马尼亚(+40)'},
  {key: '7', value: '俄罗斯(+7)'},
  {key: '1758', value: '圣卢西亚(+1758)'},
  {key: '1784', value: '圣文森特(+1784)'},
  {key: '684', value: '东萨摩亚(+684)'},
  {key: '685', value: '西萨摩亚(+685)'},
  {key: '378', value: '圣马力诺 (+378)'},
  {key: '239', value: '圣多美和普林西比(+239)'},
  {key: '966', value: '沙特阿拉伯(+966)'},
  {key: '221', value: '塞内加尔(+221)'},
  {key: '248', value: '塞舌尔(+248)'},
  {key: '232', value: '塞拉利(+232)'},
  {key: '65', value: '新加坡(+65)', reg: 'en-sg'},
  {key: '421', value: '斯洛伐克(+421)'},
  {key: '386', value: '斯洛文尼亚(+386)'},
  {key: '677', value: '所罗门群岛(+677)'},
  {key: '252', value: '索马里(+252)'},
  {key: '27', value: '南非(+27)', reg: 'en-za'},
  {key: '34', value: '西班牙(+34)'},
  {key: '94', value: '斯里兰卡(+94)'},
  {key: '1758', value: '圣卢西亚(+1758)'},
  {key: '1784', value: '圣文森特和格林纳丁斯(+1784)'},
  {key: '249', value: '苏丹(+249)'},
  {key: '597', value: '苏里南(+597)'},
  {key: '268', value: '斯威士兰(+268)'},
  {key: '46', value: '瑞典(+46)'},
  {key: '41', value: '瑞士(+41)'},
  {key: '963', value: '叙利亚(+963)'},
  {key: '886', value: '中国台湾(+886)', reg: 'zh-tw'},
  {key: '992', value: '塔吉克斯坦(+992)'},
  {key: '255', value: '坦桑尼亚(+255)'},
  {key: '66', value: '泰国(+66)'},
  {key: '228', value: '多哥(+228)'},
  {key: '676', value: '汤加(+676)'},
  {key: '1868', value: '特立尼达和多巴哥(+1868)'},
  {key: '216', value: '突尼斯(+216)'},
  {key: '90', value: '土耳其 (+90)'},
  {key: '993', value: '土库曼斯坦(+993)'},
  {key: '256', value: '乌干达(+256)'},
  {key: '380', value: '乌克兰(+380)'},
  {key: '971', value: '阿拉伯联合酋长国(+971)'},
  {key: '44', value: '英国(+44)', reg: 'en-gb'},
  {key: '598', value: '乌拉圭(+598)'},
  {key: '233', value: '乌兹别克斯坦(+233)'},
  {key: '58', value: '委内瑞拉(+58)'},
  {key: '84', value: '越南(+84)'},
  {key: '967', value: '也门(+967)'},
  {key: '381', value: '南斯拉夫(+381)'},
  {key: '263', value: '津巴布韦(+263)'},
  {key: '243', value: '刚果(+243)'},
  {key: '260', value: '赞比亚(+260)'}
]
const phoneReg = {
  'ar-dz': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-sy': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-sa': /^(!?(\+?966)|0)?5\d{8}$/,
  'en-us': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  'cs-cz': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'de-de': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  'da-dk': /^(\+?45)?(\d{8})$/,
  'el-gr': /^(\+?30)?(69\d{8})$/,
  'en-au': /^(\+?61|0)4\d{8}$/,
  'en-gb': /^(\+?44|0)7\d{9}$/,
  'en-hk': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
  'en-in': /^(\+?91|0)?[789]\d{9}$/,
  'en-nz': /^(\+?64|0)2\d{7,9}$/,
  'en-za': /^(\+?27|0)\d{9}$/,
  'en-zm': /^(\+?26)?09[567]\d{7}$/,
  'es-es': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'fi-fi': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
  'fr-fr': /^(\+?33|0)[67]\d{8}$/,
  'he-il': /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/,
  'hu-hu': /^(\+?36)(20|30|70)\d{7}$/,
  'it-it': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-jp': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
  'ms-my': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-no': /^(\+?47)?[49]\d{7}$/,
  'nl-be': /^(\+?32|0)4?\d{8}$/,
  'nn-no': /^(\+?47)?[49]\d{7}$/,
  'pl-pl': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-br': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  'pt-pt': /^(\+?351)?9[1236]\d{7}$/,
  'ru-ru': /^(\+?7|8)?9\d{9}$/,
  'sr-rs': /^(\+3816|06)[- \d]{5,9}$/,
  'tr-tr': /^(\+?90|0)?5\d{9}$/,
  'vi-vn': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  'zh-cn': /^(\+?0?86\-?)?1[345789]\d{9}$/,
  'zh-tw': /^(\+?886\-?|0)?9\d{8}$/
}
const OrderStatus = {
  未生成: 1,
  待接单: 11,
  待支付: 12,
  待下单: 13,
  下单中: 14,
  待发货: 15,
  待收货: 16,
  已完成: 20,
  已取消: 30
}
const TransportStatus = [
  {value: -1, label: '预报状态'},
  {value: 1, label: '待预报'},
  {value: 2, label: '已预报'},
  {value: 3, label: '无需预报'},
  {value: 0, label: '其他'},
]

const InternationalAmountStatusArray = [
  {value: -1, label: '支付状态'},
  {value: 1, label: '预支付'},
  {value: 2, label: '包邮'},
  {value: 3, label: '运费实收'},
  {value: 4, label: '实收已支付'},
  {value: 5, label: '实收待支付'},
  {value: 6, label: '实收待计算'},
  {value: 7, label: '只下单不转运'}
]

const KEYS = [
  {
					key: 'color_list',
					name: '颜色',
				},{
					key: 'size_list',
					name: '尺码',
				}, {
					key: 'volume_list',
					name: '容量',
				}, {
					key: 'material_list',
					name: '材质',
				}, {
					key: 'band_list',
					name: '胸围',
				}, {
					key: 'cup_list',
					name: '罩杯',
				},{
					key: 'scent_list',
					name: '容量',
				}, {
					key: 'width_list',
					name: '宽度',
				},{
					key: 'series_list',
					name: '系列',
				}
]

export {
  FILE_HOST,
  API_HOST,
  API2_HOST,
  API3_HOST,
  BASE_HOST,
  ADMIN_HOST,
  default_crawler,
  AIService_HOST,
  ONEKEY_HOST,
  KEYS,
  COUNTRIES,
  CURRENCIES,
  SIDEMENU,
  POSTMENU,
  SINGLESIDEMENU,
  SHIPPINGMANAGERSIDEMENU,
  USERMENU,
  BANKLIST,
  areaCode,
  phoneReg,
  OrderStatus,
  TransportStatus,
  InternationalAmountStatusArray,
  lackDisplay,
  specOrder,
  APPPages,
  SPEC_MAPPER
}



// WEBPACK FOOTER //
// ./src/services/constant.js